import React from "react";
import { useNavigate } from "react-router-dom"

const Unauthorized = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);

    return (
        <section>
            <h1>Unauthorized</h1>
            <br />
            <p>You are not authorized to access this application. Please contact your manager for access.</p>
            <div className="flexGrow">
                <button data-testid='btnGoBack' onClick={goBack}>Go Back</button>
            </div>
        </section>
    )
}

export default Unauthorized
